var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_528_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.17157 2.75738L7 5.58581L9.82843 2.75738L11.2426 4.1716L8.41421 7.00002L11.2426 9.82845L9.82843 11.2427L7 8.41424L4.17157 11.2427L2.75736 9.82845L5.58579 7.00002L2.75736 4.1716L4.17157 2.75738Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_528_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
export default __webpack_public_path__ + "static/media/close-icon.538b9bf7.svg";
export { SvgComponent as ReactComponent };